import axios from "axios";
import apiClient from "../utils/apiClient";

export const getAllFlows = async () => {
  try {
    const response = await apiClient().get(`call_flows/`);

    return response.data;
  } catch (error) {
    console.error("Error while getting all flows data", error);
    //return error
  }
};

export const getFlowById = async (id) => {
  try {
    const response = await apiClient().get(
      `call_flows/call_flow_detail/${id}/`
    );
    return response;
  } catch (error) {
    console.error("Error while getting flow by Id", error);
    return error.response;
  }
};

export const getFlowsByWorkspaceId = async (workspace_id) => {
  try {
    const response = await apiClient().get(
      `call_flows/get_all_by_workspace_id/${workspace_id}/`
    );
    return response.data;
  } catch (error) {
    console.error("Error while getting all flows by workspace_id", error);
    //return error
  }
};

const giveBackendUrlByParams = (params) => {
  return `${process.env.REACT_APP_QA_TELESERVER_URL}${params}/`;
};

export const makeCallQA = async (data, backend, custom_backend_url) => {
  let backend_url;

  if (backend) {
    backend_url = giveBackendUrlByParams(backend);
  } else if (custom_backend_url && custom_backend_url.trim()) {
    if (custom_backend_url.endsWith("/")) {
      backend_url = custom_backend_url;
    } else {
      backend_url = custom_backend_url + "/";
    }
  } else {
    backend_url = `${process.env.REACT_APP_QA_TELESERVER_URL}server2/`;
  }
  try {
    const response = await axios.post(`${backend_url}make_call_v3`, data);

    return response;
  } catch (error) {
    console.error("Error while make call", error);
    //return error
  }
};

// V2 / agentic flows are served by the V2 teleserver and use a different
// call API + payload than V1's make_call_v3. Custom Backend works the same way
// as V1: when set, it is the URL prefix before the constant api/public/call
// suffix; blank falls back to the default V2 gateway.
export const makeCallV2 = async ({
  agent_id,
  phone_number,
  variable_values,
  custom_backend_url,
}) => {
  try {
    let base = `${process.env.REACT_APP_TELESERVER_API_URL}`;
    if (custom_backend_url && custom_backend_url.trim()) {
      base = custom_backend_url.endsWith("/")
        ? custom_backend_url
        : custom_backend_url + "/";
    }
    const response = await axios.post(
      `${base}api/public/call`,
      { agent_id, phone_number, variable_values },
      {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_X_API_KEY_PUBLIC,
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error while making V2 call", error);
    return error.response;
  }
};

export const makeCallProd = async (id, data) => {
  try {
    const response = await apiClient().post(
      `call_flows/make_call/${id}/`,
      data
    );

    return response;
  } catch (error) {
    console.error("Error while make call", error);
    //return error
  }
};
